module.exports = __webpack_public_path__ + "img/home_bg_top.00947958.png";